<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :dateRangeMenu="false"></graph-tool-bar>
      <br />
    </div>

    <div class="md-layout-item md-size-100">
      <slide-y-up-transition :duration="40">
        <md-empty-state
          v-show="!validTokens.length && !inValidTokens.length"
          md-icon="vpn_key"
          :md-label="$lang.titles.generate_first_token"
          :md-description="$lang.messages.no_tokens_available"
        >
          <md-button class="md-success" @click="openModal()">{{$lang.keys.generate_new_token}}</md-button>
        </md-empty-state>
      </slide-y-up-transition>

      <div class="text-center" v-show="validTokens.length || inValidTokens.length">
        <md-button class="md-success" @click="openModal()">{{$lang.keys.generate_new_token}}</md-button>
      </div>
    </div>

    <slide-y-down-transition>
      <div class="md-layout-item md-size-100" v-if="validTokens.length">
        <tokens-table 
        :cardtitle="$lang.titles.valid_tokens"
        :valid="true"
        :tableData="validTokens"
        ></tokens-table>
      </div>
    </slide-y-down-transition>

    <slide-y-down-transition>
      <div class="md-layout-item md-size-100" v-if="inValidTokens.length">
        <tokens-table 
        :cardtitle="$lang.titles.invalid_tokens"
        :valid="false"
        :tableData="inValidTokens"
        ></tokens-table>
      </div>
    </slide-y-down-transition>

    <modal v-if="showModal" @close="modalClose">
      <template slot="header">
        <h4 class="modal-title">{{$lang.titles.token_validity}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalClose">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <v-date-picker
          v-model="selectedDate"
          :min-date="min_date"
          :max-date="max_date"
          :firstDayOfWeek="2"
          is-inline
          is-expanded
          nav-visibility="visible"
        ></v-date-picker>
<br>
        <md-field>
          <label>{{$lang.titles.note}}</label>
          <md-input
            v-model="tokenNote"
            type="text"
          ></md-input>
        </md-field>
        <br>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="generateNewToken()">{{$lang.keys.generate}}</md-button>
        <md-button class="md-simple" @click="modalClose">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import axios from "axios";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import { format, endOfDay, differenceInSeconds } from "date-fns";
import { Modal } from "@/components";

import { SlideYUpTransition, SlideYDownTransition } from "vue2-transitions";

import TokensTable from "./TokensTable";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    Modal,
    SlideYUpTransition,
    SlideYDownTransition,
    TokensTable
  },
  data() {
    return {
      validTokens: [],
      inValidTokens: [],
      showModal: false,
      selectedDate: null,
      tokenNote: ""
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    min_date() {
      return new Date();
    },
    max_date() {
      return new Date().setFullYear(new Date().getFullYear() + 1);
    }
  },
  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.getData();
      }
    }
  },
  created() {
    this.$store.commit("setLoading", true);
    this.getData();
  },

  methods: {
    openModal() {
      let dt = new Date();
      dt.setMonth(new Date().getMonth() + 1);
      this.selectedDate = dt;
      this.tokenNote = "";

      this.showModal = true;
    },

    modalClose() {
      this.showModal = false;
    },

    formatDate(ts) {
      return format(ts * 1000, "DD-MM-YYYY HH:mm:ss");
    },

    getData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/tools/integration",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          order: "DESC"
        },
        withCredentials: true
      })
        .then(response => {
          this.validTokens = [];
          this.inValidTokens = [];

          response.data.data.forEach(el => {
            if (el.validity) {
              this.validTokens.push({
                ID: el.ID,
                generated: this.formatDate(el.timestamp),
                expiration: this.formatDate(el.expiration),
                token_full: el.token,
                token_short: el.token.slice(0, 20) + " ...",
                note: el.note
              });
            } else {
              this.inValidTokens.push({
                ID: el.ID,
                generated: this.formatDate(el.timestamp),
                expiration: this.formatDate(el.expiration),
                token_full: el.token,
                token_short: el.token.slice(0, 20) + " ...",
                note: el.note
              });
            }
          });

          setTimeout( () => {
            this.$store.commit("setLoading", false);
          }, 600);
        })
        .catch(error => {
          if (error.response) {
            this.validTokens = [];
            this.inValidTokens = [];
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    generateNewToken() {
      const validityTS = endOfDay(this.selectedDate);

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/tools/integration",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          life_time: differenceInSeconds(validityTS, new Date()),
          note: this.tokenNote
        },
        withCredentials: true
      })
        .then(response => {
          this.getData();
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
      this.modalClose();
    }
  }
};
</script>

<style scoped>
.md-toolbar {
  position: inherit;
}
</style>